import React from 'react';
import { useField } from 'formik';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import { cn } from '@/lib/utils';

interface FormCheckboxProps {
    name: string;
    label?: string;
    helpText?: string;
    className?: string;
    disabled?: boolean;
    required?: boolean;
    validate?: (value: unknown) => string | undefined;
}

export const FormCheckbox: React.FC<FormCheckboxProps> = ({
    name,
    label,
    helpText,
    className,
    disabled,
    required,
    validate,
}) => {
    const validateFn = (value: unknown) => {
        if (required && !value) return 'Campo obrigatório';
        if (validate) return validate(value);
        return undefined;
    };

    const [field, meta, helpers] = useField({
        name,
        type: 'checkbox',
        validate: validateFn,
    });

    return (
        <div className={cn('space-y-2', className)}>
            <div className="flex items-center space-x-2">
                <Checkbox
                    id={name}
                    checked={field.checked}
                    onCheckedChange={disabled ? undefined : helpers.setValue}
                    disabled={disabled}
                    className={cn(meta.touched && meta.error && 'border-destructive')}
                />
                {label && (
                    <Label
                        htmlFor={name}
                        className={cn(
                            meta.touched && meta.error && 'text-destructive',
                            disabled && 'opacity-50',
                        )}
                    >
                        {label} {required ? '*' : ''}
                    </Label>
                )}
            </div>
            {helpText ? (
                <p className="pl-6 text-sm leading-relaxed text-muted-foreground">{helpText}</p>
            ) : null}
            {meta.touched && meta.error ? (
                <p className="text-[0.8rem] font-medium text-destructive">{meta.error}</p>
            ) : null}
        </div>
    );
};
